import { render, staticRenderFns } from "./PerformSearch.vue?vue&type=template&id=7aada6b2&"
import script from "./PerformSearch.vue?vue&type=script&lang=ts&"
export * from "./PerformSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports